// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';

/**
 * Generic scaffold placeholder for screens whose full build is deferred to a
 * follow-up PR (Manager/Executive surfaces, Bills, Access). Renders a Carbon-
 * themed panel so the shell is navigable end-to-end.
 */
export default function Scaffold({
  title,
  blurb,
  children,
}: {
  title: string;
  blurb?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="hs-scaffold" data-testid="scaffold">
      <span className="hs-badge-soon">Scaffold · full build in a follow-up PR</span>
      <h2>{title}</h2>
      {blurb && <p>{blurb}</p>}
      {children}
    </div>
  );
}
